import { gql, useMutation } from 'urql'
import { PartialBrief } from '../../../Types/Brief'
import { InputMaybe } from '../../../Types/generated-types'
import getSubmissionParams from './getSubmissionParams'

export type CreateEventInput = {
  eventTypeID: number
  lat: string
  lon: string
  location: string
  radius: string
  attendees: number
  layoutID: string
  isFlexibleWithDates: boolean
  flexibleDatesNote: string
  fromDateTime: string
  toDateTime: string
  spaceFacilityIDs: number[]
  cateringNeeds?: string
  currency: string
  budget: number
  name: string
  additionalNotes?: string
  guestID: number
  guestCompany: string
  automatedInvitationsQualified: boolean
  automatedInvitationsBypassed: boolean
  accountManagerId?: number
  styleIDs: string[]
}

const getIsoDateTime = (
  date: InputMaybe<string> | undefined,
  time: InputMaybe<string> | undefined
): string => `${date?.split('T')[0]}T${time}`

export const getBizPlatformSubmissionParams = (partialBrief: PartialBrief): CreateEventInput => {
  const brief = getSubmissionParams(partialBrief)

  return {
    eventTypeID: Number(brief.collection),
    lat: brief.lat,
    lon: brief.lon,
    location: brief.location,
    radius: brief.radius?.toString() || '',
    attendees: brief.capacities,
    layoutID: brief.layouts?.toString() || '',
    isFlexibleWithDates: !!brief.flexibleDates,
    flexibleDatesNote: brief.flexibleDatesNote || '',
    fromDateTime: getIsoDateTime(brief.fromDate, brief.fromTime),
    toDateTime: getIsoDateTime(brief.toDate, brief.toTime),
    spaceFacilityIDs: brief.spaceFacilityIds || [],
    cateringNeeds: brief.cateringNeeds?.toString(),
    currency: brief.currency?.toString() || '',
    budget: brief.budget,
    name: brief.eventName || '',
    additionalNotes: brief.additionalNotes?.toString(),
    guestID: Number(partialBrief.userId),
    guestCompany: partialBrief.guest?.company || '',
    automatedInvitationsQualified: false,
    automatedInvitationsBypassed: false,
    styleIDs: brief.styleIds || [],
  }
}

type CreateEventMutation = {
  createEvent?: {
    ID: number
  }
}

type CreateEventVariables = {
  input: CreateEventInput
}

const CreateEventDocument = gql`
  mutation createEvent($input: CreateEventInput!) {
    createEvent(input: $input) {
      ID
    }
  }
`

export const useSubmitBizBriefMutation = () =>
  useMutation<CreateEventMutation, CreateEventVariables>(CreateEventDocument)
